import { BASE_ROUTE, RouteParams } from "../../../constants";

export const BASE_DASHBOARD_ROUTE = `${BASE_ROUTE}/dashboard`;
export const BASE_PROGRAMMES_ROUTE = `${BASE_ROUTE}/programmes`;
export const BASE_PROJECT_ROUTE = `${BASE_ROUTE}/projects`;
export const BASE_USER_ROUTE = `${BASE_ROUTE}/users`;

export const ShellPages = {
  dashboards: {
    index: {
      path: `/`,
      generateLink: (organisationId: number | string) =>
        `/${BASE_DASHBOARD_ROUTE.replace(RouteParams.organisationId, organisationId + "")}`
    },
    impacts: {
      path: `/impacts`,
      generateLink: (organisationId: number | string) =>
        `/${BASE_DASHBOARD_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/impacts`
    },
    actions: {
      path: `/actions`,
      generateLink: (organisationId: number | string) =>
        `/${BASE_DASHBOARD_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/actions`
    },
    userStakeholders: {
      path: `/userStakeholders`,
      generateLink: (organisationId: number | string) =>
        `/${BASE_DASHBOARD_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/userStakeholders`
    },
    overdueActions: {
      path: `/overdueActions/${RouteParams.type}`,
      generateLink: (organisationId: number | string, type: string) =>
        `/${BASE_DASHBOARD_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/dashboard/overdueActions/${type}`
    },
    upcomingActions: {
      path: `/upcomingActions/${RouteParams.type}`,
      generateLink: (organisationId: number | string, type: string) =>
        `/${BASE_DASHBOARD_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/dashboard/upcomingActions/${type}`
    }
  },
  organisations: {
    index: {
      path: `/${RouteParams.organisationId}`,
      generateLink: (organisationId: number | string) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}`
    },
    users: {
      path: `/users/${RouteParams.userId}`,
      generateLink: (organisationId: string | number, userId: number | string) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/users/${userId}`
    },
    stakeholders: {
      path: `/stakeholders/${RouteParams.stakeholderId}`,
      generateLink: (organisationId: string | number, stakeholderId: number | string) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/stakeholders/${stakeholderId}`
    },
    createProgramme: {
      path: `/create/programme`,
      generateLink: (organisationId: string | number) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/create/programme`
    },

    createProject: {
      path: `/create/project`,
      generateLink: (organisationId: string | number) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/create/project`
    },
    coreData: {
      index: {
        path: `/core-data/business-areas`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/business-areas`
      },
      places: {
        path: `/core-data/place-groups`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/place-groups`
      },
      locations: {
        path: `/core-data/locations`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/locations`
      },
      processes: {
        path: `/core-data/processes`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/processes`
      },
      trainingProgress: {
        path: `/core-data/training-progress`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/training-progress`
      },
      roles: {
        path: `/core-data/roles`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/roles`
      },
      actionTypes: {
        path: `/core-data/action-types`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/action-types`
      },
      impactTypes: {
        path: `/core-data/impact-types`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/impact-types`
      },
      labels: {
        path: `/core-data/labels`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/labels`
      },
      stakeholders: {
        path: `/core-data/stakeholders`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/stakeholders`
      },
      trainingTypes: {
        path: `/core-data/training-types`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/core-data/training-types`
      }
    },
    visualisations: {
      index: {
        path: `/visualisations`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/visualisations`
      },
      heatmap: {
        path: `/visualisations/heatmap/${RouteParams.section}`,
        generateLink: (organisationId: string | number, section: string) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/visualisations/heatmap/${section}`
      },
      sunburst: {
        path: `/visualisations/sunburst`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/visualisations/sunburst`
      },
      timeline: {
        path: `/visualisations/timeline`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/visualisations/timeline`
      },
      capacity: {
        path: `/visualisations/capacity`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/visualisations/capacity`
      },
      places: {
        path: `/visualisations/places`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/visualisations/places`
      }
    },
    settings: {
      index: {
        path: `/settings/index`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/settings/index`
      },
      users: {
        path: `/settings/users`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/settings/users`
      },
      admin: {
        path: `/settings/admin`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/settings/admin`
      }
    }
  },
  programmes: {
    index: {
      path: ``,
      generateLink: (organisationId: number | string, projectId: number | string) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/programmes/${projectId}`
    },
    settings: {
      index: {
        path: `/settings/index`,
        generateLink: (organisationId: string | number, programmeId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/programmes/${programmeId}/settings/index`
      },
      milestones: {
        path: `/settings/milestones`,
        generateLink: (organisationId: string | number, programmeId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/programmes/${programmeId}/settings/milestones`
      }
    }
  },
  projects: {
    index: {
      path: ``,
      generateLink: (organisationId: number | string, projectId: number | string) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}`
    },
    programmes: {
      index: {
        path: `/${RouteParams.projectId}/programmes/${RouteParams.programmeId}`,
        generateLink: (organisationId: number | string, projectId: number | string, programmeId: string | number) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/programmes/${programmeId}`
      },
      locations: {
        path: `/${RouteParams.projectId}/programmes/${RouteParams.programmeId}/locations`,
        generateLink: (organisationId: number | string, projectId: number | string, programmeId: string | number) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/programmes/${programmeId}/locations`
      }
    },
    organisationVisualisations: {
      sunburst: {
        path: `/${RouteParams.projectId}/organisations/visualisations/sunburst`,
        generateLink: (organisationId: number | string, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/organisations/visualisations/sunburst`
      },
      timeline: {
        path: `/${RouteParams.projectId}/organisations/visualisations/timeline`,
        generateLink: (organisationId: number | string, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/organisations/visualisations/timeline`
      },
      capacity: {
        path: `/${RouteParams.projectId}/organisations/visualisations/capacity`,
        generateLink: (organisationId: number | string, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/organisations/visualisations/capacity`
      },
      heatmap: {
        path: `/${RouteParams.projectId}/organisations/visualisations/heatmap/${RouteParams.section}`,
        generateLink: (organisationId: number | string, projectId: number | string, section: string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/organisations/visualisations/heatmap/${section}`
      },
      places: {
        path: `/${RouteParams.projectId}/organisations/visualisations/places`,
        generateLink: (organisationId: number | string, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/organisations/visualisations/places`
      }
    },
    settings: {
      index: {
        path: `/settings/index`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/settings/index`
      },
      milestones: {
        path: `/settings/milestones`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/settings/milestones`
      },
      benefits: {
        path: `/settings/benefits`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/settings/benefits`
      },
      phases: {
        path: `/settings/phases`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/settings/phases`
      },
      permissions: {
        path: `/settings/permissions`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `/${BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/settings/permissions`
      }
    }
  },
  users: {
    auth: {
      loginComplete: {
        path: `/login_complete`,
        generateLink: () => `/login_complete`
      }
    },
    index: {
      path: `/settings`,
      generateLink: () => `/${BASE_ROUTE}/users/settings`
    },
    settings: {
      index: {
        path: `/settings`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/users/settings`
      },
      password: {
        path: `/password`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/users/password`
      },
      organisations: {
        path: `/organisations`,
        generateLink: (organisationId: string | number) =>
          `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/users/organisations`
      }
    },
    userSettings: {
      path: `/${RouteParams.userId}`,
      generateLink: (organisationId: string | number, identityKey: string) =>
        `/${BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/users/${identityKey}`
    }
  }
};
